<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Pré-Projeto - Admin</h2>
      <h3>Exportar</h3>
    </div>
    <div class="col-lg-2"></div>
  </div>
            <div class="system-table p-h-lg">
              <div class="system-table-conteiner">
                <table>
                  <thead>
                    <tr>
                      <th>Exportar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="td-name"><a href="#" (click)="openPrintModal($event,1)">Projetos</a></td>
                    </tr>
                    <tr>
                      <td class="td-name"><a href="#" (click)="openPrintModal($event,2)">Projetos - Caderno</a></td>
                    </tr>
                    <tr>
                      <td class="td-name"><a href="#" (click)="openPrintModal($event,3)">Projetos - Produtos</a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
  <ng-template #modalPPExport>
    <div class="modal-header">
      <h4 class="modal-title pull-left">Escolha de Processo</h4>
      <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closePrintModal()">
        <span aria-hidden="true" class="visually-hidden">&times;</span>
      </button>
    </div>
    <div class="modal-body table-form">
      <div class="form-group row">
        <div class="col-sm-12 m-b">
          <label class="col-sm-12 pb-1">Processo</label>
            <ng-select id="process_id" class="ng-select-alternative" [items]="processList" [ngModel]="process_id" bindLabel="title" bindValue="id" (change)="modificaId($event)" >
            </ng-select>
        </div>
      </div>
  
      <div class="hr-line-dashed"></div>
      <div class="form-group row d-flex justify-content-end">
        <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
          <button class="btn btn-white m-r-xs" type="button" (click)="closePrintModal()">Fechar</button>
          <button class="btn btn-primary" type="button" (click)="exportar()">Exportar</button>
        </div>
      </div>
    </div>
  </ng-template>
  <app-loading [loader]="isLoading"></app-loading>